// start:ng42.barrel
export * from './elipsis.pipe';
export * from './sanitize-url.pipe';
// end:ng42.barrel

